import { render, staticRenderFns } from "./addcase.vue?vue&type=template&id=1f5f89bc&scoped=true&"
import script from "./addcase.vue?vue&type=script&lang=js&"
export * from "./addcase.vue?vue&type=script&lang=js&"
import style0 from "./addcase.vue?vue&type=style&index=0&id=1f5f89bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5f89bc",
  null
  
)

export default component.exports